import type { Hotkey } from './types';

export const isMac = (): boolean => /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);

/**
 * Format hotkey for display (e.g., "⇧⌘P" on Mac or "Shift+Ctrl+P" on Windows)
 */
export const formatHotkey = (hotkey: Hotkey | undefined): string => {
  if (!hotkey) return '';

  const mac = isMac();
  const parts: string[] = [];

  if (hotkey.shift) parts.push(mac ? '⇧' : 'Shift');
  if (hotkey.ctrl && !mac) parts.push('Ctrl');
  if (hotkey.alt) parts.push(mac ? '⌥' : 'Alt');
  if (hotkey.meta) parts.push(mac ? '⌘' : 'Ctrl');

  parts.push(hotkey.key.toUpperCase());

  return parts.join(mac ? '' : '+');
};

/**
 * Check if a keyboard event matches a hotkey definition
 */
export const matchesHotkey = (event: KeyboardEvent, hotkey: Hotkey): boolean => {
  const mac = isMac();

  if (event.key.toLowerCase() !== hotkey.key.toLowerCase()) {
    return false;
  }

  const ctrlOrCmd = mac ? event.metaKey : event.ctrlKey;

  if (hotkey.ctrl !== undefined && event.ctrlKey !== hotkey.ctrl) return false;
  if (hotkey.shift !== undefined && event.shiftKey !== hotkey.shift) return false;
  if (hotkey.alt !== undefined && event.altKey !== hotkey.alt) return false;
  if (hotkey.meta !== undefined && ctrlOrCmd !== hotkey.meta) return false;

  return true;
};
